"use strict";

Fotobook.textValidator = {
    commonSymbols: "\n\t\r\\s\u200B",
    validateText: function(node, font, autoremove) {
        if (!$.trim(node.textContent).length) {
            return {};
        }
        const content = node.textContent;
        const symbols = this.commonSymbols + font.symbols.replace(/[-\\\]^]{1}/gu, '\\$&');
        const reg = new RegExp(`[^${symbols}]{1}`, 'gu');
        const deleted = {};
        const newContent = content.replace(reg, function (c, pos, full) {
            deleted[c] = true;
            return '';
        });
        const changed = content !== newContent;

        if (autoremove && changed) {
            node.textContent = newContent;
        }
        return deleted;
    },

    validateOneNode: function(node, font, autoremove, forceFont) {
        var newFont,
            deleted = {};

        if (node.nodeType === Node.TEXT_NODE) {
            return this.validateText(node, font, autoremove);
        }
        if (node.style.fontFamily?.length) {
            newFont = Fotobook.store.getters['Fonts/getFontByFamily'](node.style.fontFamily);
            if (!newFont) {
                node.style.fontFamily = null;
            } else if (!forceFont) { // Костыль, проблема: при валидации fontFamily узла переопределяет шрифт, переданный при вызове
                font = newFont;
            }
        }
        for (var i=0, l=node.childNodes.length; i<l; i++) {
            $.extend(deleted, this.validateOneNode(node.childNodes[i], font, autoremove));
        }
        return deleted;
    },

    validateCaption: function($container, font, autoremove) {
        var widget = this,
            deleted = {}, n, savedSelection;

        if (!($container instanceof jQuery)) {
            $container = $($container);
        }
        $container.find('.rangySelectionBoundary').remove();
        if (autoremove) {
            savedSelection = rangy.saveSelection();
        }
        $container.each(function(n, node) {
            $.extend(deleted, widget.validateOneNode(node, font, autoremove, true));
        });
        if (savedSelection) {
            if (Object.keys(deleted).length) {
                rangy.restoreSelection(savedSelection);
            }
            rangy.removeMarkers(savedSelection);
        }
        return deleted;
    },

    /**
     * Возвращает текущее положение курсора
     * Функциоя упрощена - считается, что в данный момент активен один блок с contenteditable
     * и курсор находится в нём. Возможно, придётся в будущем делать что-то более сложное
     */
    getCurrentRange() {
        const selection = window.getSelection();
        if (!selection.rangeCount) {
            return null;
        }
        return selection.getRangeAt(0);
    },


    execContentReadOnly: function(value) {
        if (document.queryCommandSupported('contentReadOnly')) {
            document.execCommand('contentReadOnly', false, Boolean(value));
        }
    },

    getDeletedDialogString: function(deleted) {
        return '<div class="deleted-symbols-dialog-string">' + deleted.join('') + '</div>';
    },
    /**
     * Показывает окно со списком удалённых символов
     * восстанавливает позицию курсора
     */
    showDeletedSymbolsAlert: function(deleted, focus) {
        const savedRange = this.getCurrentRange(),
              doNotAskKey = 'symbolsRemovedAlert',
              message = t('photobook-js-fonts-validation-message', {
                  symbols: this.getDeletedDialogString(deleted),
              });

        const $dialog = Fotobook.dialog.alert(message, {
            title: t('photobook-js-warning'),
            doNotAskKey: doNotAskKey,
            doNotAskCallback: () => {
                Fotobook.notification.showWarning(message);
            },
            resolved: !deleted.length,
        });
        // Выполняем манипуляции с курсором, если окно реально показалось
        // нет апи, позволяющего определить состояние промиса, так что проверяем наличие окна
        if (savedRange && $dialog.length) {
            // убираем все ranges, чтобы не вводились символы в контейнер, пока мы наблюдаем окно
            window.getSelection().removeAllRanges();
            this.execContentReadOnly(true);
            $dialog.catch(() => null).finally(() => {
                this.execContentReadOnly(false);
                if (focus) {
                    this.collapse(savedRange.startContainer, savedRange.startOffset);
                }
            })
        }

        return $dialog;
    },

    /**
     * Показывает запрос со списком удалённых символов
     */
    showDeletedSymbolsConfirm: function(deleted) {
        const message = t('photobook-js-fonts-validation-confirm', {
            symbols: this.getDeletedDialogString(deleted),
        });

        return new Promise((resolve, reject) => {
            this.execContentReadOnly(true);
            Fotobook.dialog.confirm(message, {
                title: t('photobook-js-warning'),
                doNotAskKey: 'symbolsRemovedConfirm',
                doNotAskCallback: () => Fotobook.notification.showWarning(message),
                resolved: !deleted.length,
            }).then(resolve).catch(reject).finally(() => this.execContentReadOnly(false));
        });
    },

    /**
     * Обрабатывает содержимое ноды на предмет недопустимых символов
     * в зависимости от опций, удаляет сразу или после запроса
     * может показывать информационное окно со списком удалённых символов
     * сохраняет позицию курсора
     */
    validate: function($container, options) {
        options = $.extend({
            alert: false,
            confirm: false,
            focus: true,
            family: $container.css('font-family'),
        }, options || {});

        return new Promise((resolve, reject) => {
            const font = Fotobook.store.getters['Fonts/getFontByFamily'](options.family);
            const deleted = Object.keys(this.validateCaption($container, font, !options.confirm));

            if (!deleted.length) {
                resolve();
                return;
            }

            if (options.confirm) {
                this.showDeletedSymbolsConfirm(deleted, options).then(() => {
                    this.validateCaption($container, font, true);
                    resolve();
                }).catch(reject);
                return;
            }

            if (options.alert) {
                // В ИЕ если использовать timeout = 0 в setTimeout (нужно, чтобы код исполнился после обрабатываемого события)
                // значения 0 недостаточно, и возникают проблемы с положением курсора (мб есть более вменяемое решение?)
                setTimeout(() => this.showDeletedSymbolsAlert(deleted, options.focus), 10);
            }

            resolve();
        });
    },

    div: $(document.createElement('div')),
    /**
     * Подготавливает текст для вставки в текстовый контейнер:
     *     - удаляет вёрстку
     *     - удаляет недопустимые символы
     *     - заменяет переводы строк на теги <br>
     */
    prepareForPaste: function(html, options) {
        if (String.prototype.normalize) {
            html = html.normalize('NFC');
        }

        var text;
        var selection = window.getSelection();
        var range = selection.getRangeAt(0);
        var startContainer = range.startContainer;

        while (startContainer.nodeType !== Node.ELEMENT_NODE) {
            startContainer = startContainer.parentNode;
        }

        html = html.replace(/<(br\s*\/?)[^>]+>/giu, '\r\n');
        this.div.html(html);
        this.validate(this.div, $.extend({
            family: $(startContainer).css('font-family'),
        }, options));
        return this.div.text().replace(/[\r\n]+/gu, '<br>');
    },

    /**
     * Устанавливает каретку ввода в нужную позицию нужного узла
     */
    collapse: function(node, offset) {
        setTimeout(function() {
            $(node).closest("[contenteditable]").focus();
            rangy.getSelection().collapse(node, offset || 0);
        }, 0);
    },

    /**
     * Устанавливает каретку ввода в позицию, определяемую координатами
     */
    setCursorToPoint: function(x, y) {
        var range, textNode, offset;

        if (document.caretPositionFromPoint) {
            range = document.caretPositionFromPoint(x, y);
            textNode = range.offsetNode;
            offset = range.offset;
        } else if (document.caretRangeFromPoint) {
            range = document.caretRangeFromPoint(event.clientX, event.clientY);
            textNode = range.startContainer;
            offset = range.startOffset;
        }

        if (textNode && textNode.nodeType == Node.TEXT_NODE) {
            this.collapse(textNode, offset);
        } else if (document.body.createTextRange) {
            try {
                range = document.body.createTextRange();
                range.moveToPoint(x, y);
                range.select();
            } catch (e) {
            }
        }
    },

    /**
     * Обработчик вставляемого в "длинные" тексты контента
     */
    richTextBeforePaste: function(html) {
        return Fotobook.textValidator.prepareForPaste(html, {
            alert: true,
        });
    },

    /**
     * Обработчик события paste на "коротких" текстовых контейнерах
     */
    plainTextPasteHandler: function(event) {
        var plainText,
            clipboardData = event.originalEvent.clipboardData || event.clipboardData,
            selection = window.getSelection(),
            range = selection.getRangeAt(0),
            startContainer = range.startContainer;

        event.preventDefault();

        while (startContainer.nodeType !== Node.ELEMENT_NODE) {
            startContainer = startContainer.parentNode;
        }

        if (clipboardData) {
            plainText = clipboardData.getData('text/plain');
        } else if (window.clipboardData) {
            plainText = window.clipboardData.getData('Text');
        } else {
            throw new Error('Cannot get text!');
        }

        plainText = Fotobook.textValidator.prepareForPaste(plainText, {
            alert: true,
        });

        if (plainText) {
            Fotobook.textValidator.insertContentToCursor(plainText);
        }
    },

    /**
     * Вставляет html-контент в позицию курсора
     */
    insertContentToCursor: function(content) {
        var self = this,
            selection = window.getSelection(),
            range = selection.getRangeAt(0),
            inserted, node, lastNode, fragment;

        if (document.queryCommandSupported('insertHTML')) {
            try {
                document.execCommand('insertHTML', false, content);
                inserted = true;
            } catch (e) {
            }
        }
        if (!inserted) {
            if (document.queryCommandSupported('ms-beginUndoUnit')) {
                document.execCommand('ms-beginUndoUnit');
            }
            fragment = document.createDocumentFragment();
            this.div.html(content);

            while (node = this.div[0].firstChild) {
                lastNode = fragment.appendChild(node);
            }
            range.deleteContents();
            range.insertNode(fragment);
            this.collapse(lastNode, lastNode.length);
            if (document.queryCommandSupported('ms-endUndoUnit')) {
                document.execCommand('ms-endUndoUnit');
            }
            inserted = true;
        }
        if (inserted) {
            setTimeout(function() {
                $(range.startContainer).closest(".text-container").trigger(Fotobook.events.TEXT_CONTAINER_CHANGED);
            }, 0);
        }
        return inserted;
    },

    /**
     * Обработчик события drop на текстовый контейнер
     */
    textContainerDropHandler: function(event) {
        event.preventDefault();

        const dataTransfer = event.dataTransfer;

        let str;
        try {
            // ИЕ не поддерживает такой mime-type, бросает ошибку
            str = dataTransfer.getData('text/plain') || '';
        } catch (e) {
            str = dataTransfer.getData('text') || '';
        }

        this.setCursorToPoint(event.clientX, event.clientY);
        str = this.prepareForPaste(str, {
            alert: true,
        });
        return this.insertContentToCursor(str);
    },
};

$(document)
// обрабатываем тексты, которые переносятся в контейнер с помощью drag'n'drop
.on('drop', '.text-content[contenteditable]', function(event) {
    Fotobook.textValidator.textContainerDropHandler(event.originalEvent);
})

// Вычищаем буфер обмена от вёрстки (короткие тексты)
.on('paste', '.text-content[contenteditable]', Fotobook.textValidator.plainTextPasteHandler)

.on('keypress', '.text-content, .redactor-editor', function(e) {
    var $this = $(this),
        widget = $this.closest('.text-container').data('fotobook-containerEditor') || $('#book .spine').data('fotobook-containerEditor');

    if (e.which === 13 && $this.closest('#spineEditor').length) {
        e.preventDefault();
        return;
    }

    if (widget) {
        setTimeout(() => {
            widget.validateTextContainer({
                alert: true,
            });
        }, 0);
    }
})
.on('input', '.text-content[contenteditable], .redactor-editor[contenteditable]', function(event) {
    const $this = $(this),
          widget = $this.closest('.text-container').data('fotobook-containerEditor') || $('#book .spine').data('fotobook-containerEditor');

    if (widget){
        widget.validateTextContainer({
            alert: true,
        });
    }
})
;
